/**
 * Endereço do servidor (API) do ambiente atual.
 *
 * O servidor mora em outro host que o front (`server.whiz.net.br`, `dev.2.whiz.net.br`…),
 * e a fonte certa em cada ambiente é `window.configs.SERVER_URL_PROD` — a mesma que todo
 * service usa (`GenericServiceBase`). Sem ela (harness, teste), cai na origem da página.
 */
export function urlDaApi(configs: { SERVER_URL_PROD?: unknown } | undefined = typeof window !== 'undefined' ? window.configs : undefined): string {
    const configurada = configs?.SERVER_URL_PROD;
    if (typeof configurada === 'string' && configurada.trim()) return configurada.trim().replace(/\/+$/, '');
    return typeof window !== 'undefined' ? window.location.origin : '';
}

/**
 * Swagger do servidor (`/doc`) — link "Documentação" do ADMIN. F-55: era fixo num host de
 * desenvolvimento sem DNS. O link "Desenvolvedor" do CLIENTE NÃO usa isto: é a URL fixa
 * `URL_DOCUMENTACAO_API_CLIENTE` (`./urlDocumentacaoApiCliente`, decisão do operador 2026-11-03).
 */
export function urlDaDocumentacaoApi(configs?: { SERVER_URL_PROD?: unknown }): string {
    return `${urlDaApi(configs)}/doc`;
}
